import script from "./MariquitasView.vue?vue&type=script&setup=true&lang=js"
export * from "./MariquitasView.vue?vue&type=script&setup=true&lang=js"

import "./MariquitasView.vue?vue&type=style&index=0&id=0794e80a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0794e80a"]])

export default __exports__